module.exports = __webpack_public_path__ + "static/media/icon-instagram.13592440.svg";